import React from 'react';
import * as ROUTES from '../../../../router/Routes';
import ContainerTemplate from '../../../../widgets/template/Container';
import PanelBloquesPedagogicosView from './PanelBloquePedagogicoView';

const BloquesPedagogicosModule = () => {
  return (
    <ContainerTemplate
      active={ROUTES.panelBloquePedagogico}
      routes={[ROUTES.controlEstudios, ROUTES.bloquesPedagogicos]}
    >
      <PanelBloquesPedagogicosView />
    </ContainerTemplate>
  );
};

export default BloquesPedagogicosModule;
